const CloseBtn =({onClick})=>{
    return (
          <span className='ml-auto text-danger' style={{fontSize:'185%'}}
            onClick = {onClick}
           ><b>&times;</b></span>
    );
 }
 export default CloseBtn;